export default {
  projectId: process.env.VUE_APP_HEAP_PROJECT_ID
}
